import SingleLineText from './SingleLineText';

export default SingleLineText;
